import {
  CENCERT_LOGO_URL,
  ADDITIONAL_LOGO_URL,
  HEADER_HEIGHT_PX,
} from '../../../constants'
import { LanguageSelector, Logo, MemoizedTimer } from '@/components'
import { useConfig } from '@/services/config'
import { getConfig } from '../../../config'
import { useLocation } from 'wouter-preact'

export function ConditionalTimer() {
  const { expirationTime, handleSessionExpired } = useConfig()

  return (
    expirationTime && (
      <MemoizedTimer
        expirationTime={expirationTime}
        onComplete={handleSessionExpired}
      />
    )
  )
}

export function Header() {
  const { expirationTime, isDocumentSigned } = useConfig()
  const [location] = useLocation()
  const { cencertLogoUrl, showAdditionalLogoInHeader, additionalLogoUrl } =
    getConfig()

  const isTimerVisible =
    expirationTime &&
    ['/session-expired', '/process-error'].indexOf(location) === -1 &&
    !isDocumentSigned

  return (
    <header
      className='bg-white fixed top-0 left-0 right-0 z-20'
      style={{ height: HEADER_HEIGHT_PX }}
    >
      <div className='px-6 lg:px-8 xl:px-12 2xl:px-20 py-1.5 flex justify-between items-center relative shadow-lg h-full gap-6'>
        <div className='flex items-center gap-2 sm:gap-4'>
          <Logo
            image={CENCERT_LOGO_URL}
            alt='Cencert Logo'
            url={cencertLogoUrl}
          />
          {showAdditionalLogoInHeader && (
            <>
              <div className='h-6 border-r border-cencert-border-gray' />
              <Logo
                image={ADDITIONAL_LOGO_URL}
                alt='Additional Logo'
                url={additionalLogoUrl}
                className='h-7'
              />
            </>
          )}
        </div>
        <div className='flex items-center gap-2.5 sm:gap-3 md:gap-6'>
          {isTimerVisible && (
            <>
              <ConditionalTimer />
              <div className='h-6 border-r border-cencert-border-gray' />
            </>
          )}
          <LanguageSelector />
        </div>
      </div>
    </header>
  )
}
